import { base64 } from '../utils/index'

import { routers, enrouters } from '@/router/router.js'
const mutations = {
  setFundsAuth(state, authArr) {
    let A = base64.encode(JSON.stringify(authArr))
    state.fundsAuth = authArr
    localStorage.setItem('A', A)
  },
  // 用户是否为机构客户 1非机构 2机构
  setUserRole(state, info) {
    let R = base64.encode(JSON.stringify(info))
    state.userRole = info
    localStorage.setItem('R', R)
  },
  // 用户信息
  setUserInfo(state, info) {
    let I = base64.encode(JSON.stringify(info))
    state.userInfo = info
    localStorage.setItem('I', I)
  },
  // home 账户余额 净值 可用保证金
  setHomeInfo(state, info) {
    let H = base64.encode(JSON.stringify(info))
    state.homeInfo = info
    localStorage.setItem('H', H)
  },
  // 面包屑
  setBread(state, bread) {
    state.bread = bread
    localStorage.setItem('bread', JSON.stringify(bread))
  },
  // 左侧
  setLeftList(state, list) {
    state.leftList = list
  },
  ensetLeftList(state, list) {
    state.leftList = list
  },
  // 设置left默认选中
  setListType(state, type) {
    state.listType = type
    localStorage.setItem('ListType', type)
  },
  // 设置帐号类型 0：模拟 1：真实 2：全有
  setAccountType(state, type) {
    state.accountType = type
    localStorage.setItem('at', type)
  },
  // 设置left展开项
  setLeftActive(state, index) {
    state.leftActive = index
    localStorage.setItem('leftActive', index)
  },
  // 增加用户tree展开
  setExpandedKey(state, row) {
    if (!row) {
      state.expandedKey = []
    } else if (row.level == 1) {
      state.expandedKey = []
      state.expandedKey.push(row.account)
    } else {
      state.expandedKey.push(row.account)
    }
  },
  // 关闭用户tree展开
  updatedExpandeKey(state, account) {
    for (let i = 0; i < state.expandedKey.length; i++) {
      if (state.expandedKey[i] == account) {
        state.expandedKey.splice(i)
        break
      }
    }
  },
  // 绑定账户
  setBindBoxStatue(state, status) {
    state.showBindBox = status
  },
  setBannerInfo(state, data) {
    state.banner = data
  },
  set_hostname(state, name) {
    if (name === 'proway') {
      name = 'prowayxau'
    }
    state.hostname = name
    state.wwwUrl = `https://www.${name}.com`
    state.serveUrl = `https://m.${name}.com/chats/chatlink.html?groupid=cc66c0521509e0b5a29ecd052c036bba&fallback=1`
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js